<template>
  <Transition name="progress-fade">
    <div
      v-if="isLoading"
      class="fixed top-0 left-0 right-0 z-50 h-1 bg-gradient-to-r from-blue-500 via-sky-500 to-cyan-500 shadow-lg"
      :style="{ width: `${progress}%` }"
      style="transition: width 0.2s ease"
    >
      <!-- Animated glow effect -->
      <div class="absolute top-0 right-0 h-full w-20 bg-gradient-to-l from-transparent to-white/30 animate-pulse"></div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

const isLoading = ref(false);
const progress = ref(0);
let progressInterval: number | null = null;

const start = () => {
  isLoading.value = true;
  progress.value = 0;

  // Simulate progress animation
  progressInterval = setInterval(() => {
    if (progress.value < 90) {
      const increment = Math.random() * 10;
      progress.value = Math.min(progress.value + increment, 90);
    }
  }, 100) as unknown as number;
};

const complete = () => {
  progress.value = 100;

  setTimeout(() => {
    isLoading.value = false;
    progress.value = 0;
    if (progressInterval) {
      clearInterval(progressInterval);
      progressInterval = null;
    }
  }, 200);
};

const error = () => {
  // Change to red color for error state
  progress.value = 100;
  setTimeout(() => {
    isLoading.value = false;
    progress.value = 0;
    if (progressInterval) {
      clearInterval(progressInterval);
      progressInterval = null;
    }
  }, 500);
};

// Expose methods to parent
defineExpose({
  start,
  complete,
  error
});

onUnmounted(() => {
  if (progressInterval) {
    clearInterval(progressInterval);
  }
});
</script>

<style scoped>
.progress-fade-enter-active,
.progress-fade-leave-active {
  transition: opacity 0.3s ease;
}

.progress-fade-enter-from,
.progress-fade-leave-to {
  opacity: 0;
}
</style>
